module.exports = __webpack_public_path__ + "neonet.png?11535f0d4f306c5d50e28e7deea8619f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/neonet.png
// module id = 985
// module chunks = 2